module.exports = __webpack_public_path__ + "img/gzip.4312916d.svg";